// A browser rejects play() when the user has not interacted with the document
// yet (NotAllowedError) or when a pause()/removal cuts a still-pending play()
// (AbortError). Both are expected outcomes of the autoplay policy, not defects.
const AUTOPLAY_REJECTION_NAMES = ['NotAllowedError', 'AbortError'];

const isAutoplayRejection = (error: unknown) =>
  AUTOPLAY_REJECTION_NAMES.includes((error as { name?: string } | null)?.name ?? '');

/**
 * Plays an audio element and swallows the two autoplay-policy rejections.
 * Every other failure is rethrown so it still reaches Sentry.
 */
async function playAudio(audio: HTMLAudioElement): Promise<void> {
  try {
    await audio.play();
  } catch (error) {
    if (!isAutoplayRejection(error)) throw error;
  }
}

export default playAudio;
